var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 6,
    fill: "#FDAB29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.567 0.75C14.7594 0.416666 15.2406 0.416667 15.433 0.75L18.0311 5.25C18.2235 5.58333 17.983 6 17.5981 6H12.4019C12.017 6 11.7765 5.58333 11.9689 5.25L14.567 0.75Z",
    fill: "#FDAB29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.433 29.25C15.2406 29.5833 14.7594 29.5833 14.567 29.25L11.9689 24.75C11.7765 24.4167 12.017 24 12.4019 24L17.5981 24C17.983 24 18.2235 24.4167 18.0311 24.75L15.433 29.25Z",
    fill: "#FDAB29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0179 23.4058C24.1175 23.7776 23.7773 24.1178 23.4055 24.0182L21.7325 23.5699C21.3607 23.4703 21.2362 23.0056 21.5083 22.7334L22.7331 21.5086C23.0053 21.2365 23.47 21.361 23.5696 21.7328L24.0179 23.4058Z",
    fill: "#FDAB29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4058 5.63836C23.7776 5.53874 24.1178 5.87894 24.0182 6.25073L23.5699 7.92376C23.4703 8.29555 23.0056 8.42007 22.7334 8.14791L21.5086 6.92316C21.2365 6.651 21.361 6.18627 21.7328 6.08665L23.4058 5.63836Z",
    fill: "#FDAB29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63836 6.25043C5.53874 5.87864 5.87894 5.53844 6.25073 5.63806L7.92376 6.08634C8.29555 6.18596 8.42007 6.65069 8.14791 6.92286L6.92316 8.1476C6.651 8.41977 6.18627 8.29525 6.08665 7.92346L5.63836 6.25043Z",
    fill: "#FDAB29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25043 24.0189C5.87864 24.1185 5.53844 23.7783 5.63806 23.4065L6.08634 21.7335C6.18596 21.3617 6.65069 21.2372 6.92286 21.5093L8.1476 22.7341C8.41977 23.0062 8.29525 23.471 7.92346 23.5706L6.25043 24.0189Z",
    fill: "#FDAB29"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.25 14.567C29.5833 14.7594 29.5833 15.2406 29.25 15.433L24.75 18.0311C24.4167 18.2235 24 17.983 24 17.5981L24 12.4019C24 12.017 24.4167 11.7765 24.75 11.9689L29.25 14.567Z",
    fill: "#FDAB29"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.433C0.416666 15.2406 0.416667 14.7594 0.75 14.567L5.25 11.9689C5.58333 11.7765 6 12.017 6 12.4019L6 17.5981C6 17.983 5.58333 18.2235 5.25 18.0311L0.75 15.433Z",
    fill: "#FDAB29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.28234167c73cd56a921e7e0c20107dbe.svg";
export { ForwardRef as ReactComponent };